import React from 'react'
import {Link} from 'react-router-dom'

import ab from './images/ab_gurung.jpg'
import bikash from './images/bikash_kc.jpg'
import binamra from './images/binamra_khadkha.jpg'
import swasthik from './images/swasthik_jung.jpg'

import './team.css'

function Team() {
    function handleOnclick(){
        window.scroll({
            top:0,
            left:0,  
        });
    }
    return (
        <div className="container-fluid bg team-fluid" id="team">
        <div className="team-container py-4 text-center" >
            <div className="row mb-4">
                <div className="col mb-4">
                    <h2 style={{color:'white'}}  id="our-team-heading">Our Team</h2>
                </div>
            </div>
            <div className="team-card-wrapper">
                <div className="team-card border-0"> 
                    <div className="team-card-inner">
                        <img src={ab} alt="" className="card-img-top img-fluid mb-1" />  
                    </div>
                    <div className="team-card-body">
                        <Link to='/player-profile'>
                            <h4 className="team-card-name">Ab Gurung</h4>  
                            <h6>Goalkeeper</h6> 
                            <h2 className="text-danger player-number">1</h2>
                        </Link>
                        <div className="d-flex flex-row justify-content-center">
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-facebook fa-lg"></i>
                                </Link>
                            </div>
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-instagram fa-lg"></i>
                                </Link>
                            </div>
                        </div>              
                    </div>
                </div>
                
                <div className="team-card border-0">
                    <div className="team-card-inner">
                        <img src={binamra} alt="" className="card-img-top img-fluid mb-1" />
                    </div>
                    <div className="team-card-body">
                    <Link to='/player-profile'>
                        <h4 className="team-card-name">Binamra Khadkha</h4>  
                        <h6>Forward</h6> 
                        <h2 className="text-danger player-number">9</h2>
                    </Link>
                        <div className="d-flex flex-row justify-content-center">
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-facebook fa-lg"></i>
                                </Link>
                            </div>
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-instagram fa-lg"></i>
                                </Link>
                            </div>
                        </div>              
                    </div>
                </div>

                <div className="team-card border-0">
                    <div className="team-card-inner">
                        <img src={swasthik} alt="" className="card-img-top img-fluid mb-1" />
                    </div>
                    <div className="team-card-body">
                    <Link to='/player-profile'>
                        <h4 className="team-card-name">Swasthik Jung</h4>  
                        <h6>Defender</h6> 
                        <h2 className="text-danger player-number">5</h2>
                    </Link>
                        <div className="d-flex flex-row justify-content-center">
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-facebook fa-lg"></i>
                                </Link>
                            </div>
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-instagram fa-lg"></i>
                                </Link>
                            </div>
                        </div>              
                    </div>
                </div>
                
                <div className="team-card border-0">
                    <div className="team-card-inner">
                        <img src={bikash} alt="" className="card-img-top img-fluid mb-1" />
                    </div>
                    <div className="team-card-body">
                        <Link to='/player-profile'>
                            <h4 className="team-card-name">Bikash KC</h4>  
                            <h6>Defender</h6> 
                            <h2 className="text-danger player-number">4</h2>
                        </Link>
                        <div className="d-flex flex-row justify-content-center">
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-facebook fa-lg"></i>
                                </Link>
                            </div>
                            <div className="px-1">
                                <Link to="#">
                                    <i className="fab fa-instagram fa-lg"></i>
                                </Link>
                            </div>
                       </div>              
                    </div>
                </div>
            </div>
        </div>
            <div className="row">
                <div className="col text-center">
                    <Link to="/view-players" alt="">
                        <button type="button" className="btn btn-outline waves-effect gallery-button" onClick={handleOnclick}>View More +</button>
                    </Link>
                    <br />
                    <br />
                    <br />
                </div>
            </div>
    </div>
    )
}

export default Team